module.exports = __webpack_public_path__ + "static/media/business-joins.b6d42871.png";